<template>
  <ul class="nav navbar-nav navbar-right">
    <!--
    <li>
      <router-link :to="{name: 'signup'}">Sign Up</router-link>
    </li>
    <li>
      <router-link :to="{name: 'login'}">Log In</router-link>
    </li>
    -->
    <li>
      <a href="https://mailchi.mp/3bf25cf56493/signup-for-landing-page">Sign Up</a>
    </li>
    <li>
      <a href="https://mailchi.mp/3bf25cf56493/signup-for-landing-page">Log In</a>
    </li>
  </ul>

</template>

<script>
// import { mapState } from 'vuex'


export default {
  name: 'navbar',
  // data() {
  //   return {
  //     isOpen: false,
  //   }
  // },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .nav .active { color: #4285f4; box-sizing: border-box }
  .nav li a:hover { background: #DDEEFF; }

  .navbar-nav { margin: 0px 60px 0px 0px; }
  .navbar li { float: left; padding:0px;}
    .navbar li a { font-size: 20px; display: block; line-height: 78px; color: #4285f4; padding: 10px 20px; font-weight: 400; }
  .navbar .active, .nav .active:focus { color: #4285f4; }
  .navbar li a:hover { border-bottom: 2px solid #4285f4; background: none; color: #4285f4; }

  @media (max-width: 1200px) {
    .navbar-nav { margin-right:20px; }
    .navbar li a { padding: 10px 10px; font-size: 16px; }
  }
  @media (max-width: 779px) {
    .navbar-right {float:none !important;}
    .navbar li { float: none; }
    .navbar .public-nav .nav li a { line-height: 40px; color: #FFFFFF; border-bottom: 1px solid #FFFFFF; text-align: center; }

  }

</style>



// WEBPACK FOOTER //
// LoggedOutLinks.vue?949ced92